import React, { useEffect } from 'react';
import { Card, Form, Select, Skeleton, Button, DatePicker } from 'antd';
import { connect } from 'react-redux';
import { BarChartOutlined, CalendarOutlined } from '@ant-design/icons';

import { fetchCells } from 'src/store/auth/actions';
import { ICell } from 'src/interfaces/user';

import { IProps } from './filter.type';
import useFilter from './filter.use';

const { Option } = Select;

const FilterScreen: React.FC<IProps> = (props) => {
  const { handleCells, cells, loading } = useFilter(props);
  const { handleSubmit, sending } = props;

  useEffect(() => {
    handleCells();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card className="mb-3 py-3">
      {loading ? (
        <Skeleton active />
      ) : (
        <Form size="small" layout="inline" onFinish={handleSubmit} style={{ width: '100%' }}>
          {/* Célula */}
          <Form.Item
            name="cellId"
            rules={[{ required: true }]}
            style={{ minWidth: 150, flex: 1 }}
          >
            <Select
              placeholder="Célula"
              allowClear
              style={{ width: '100%' }}
            >
              {cells?.map((item: ICell) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {/* Tipo de gráfico */}
          <Form.Item
            name="reportType"
            rules={[{ required: true }]}
            style={{ minWidth: 150, flex: 1 }}
          >
            <Select
              placeholder="Tipo de gráfico"
              allowClear
              suffixIcon={<BarChartOutlined />}
              style={{ width: '100%' }}
            >
              <Option value="operator">Operador</Option>
              <Option value="operation">Operação</Option>
              <Option value="operationGroup">Grupo de operações</Option>
              <Option value="efficiency">Eficiência</Option>
            </Select>
          </Form.Item>

          {/* Data */}
          <Form.Item
            name="date"
            rules={[{ required: true, message: 'Selecione uma data' }]}
            style={{ minWidth: 150, flex: 1 }}
          >
            <DatePicker
              placeholder="Data"
              format="DD/MM/YYYY"
              suffixIcon={<CalendarOutlined />}
              style={{ width: '100%' }}
            />
          </Form.Item>

          {/* Botão */}
          <Form.Item style={{ flexShrink: 0 }}>
            <Button
              loading={sending}
              htmlType="submit"
              type="primary"
              size="middle"
            >
              Gerar relatório
            </Button>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
};

export default connect(undefined, { fetchCells })(FilterScreen);
